import React, {Component} from 'react'
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Icon,
    TextField,
    Toolbar,
    Checkbox,
    FormControlLabel,
    Typography,
} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles/index'
import {bindActionCreators} from 'redux'
import ReduxGlobal from "../store/actionreducers/globalView"
import {connect} from 'react-redux'
import {constDataDialogs} from "../constants"
import moment from "moment"
import ReduxMission from "../store/actionreducers/mission"
import {UecareDropdown} from "../components";

const styles = theme => ({
    root: {},
    formControl: {
        marginBottom: 24,
        width: 'auto'
    },
})

class DownloadMissions extends Component {

    state = {
        identity: 'all',
        livingArea: false,
        missionType: 3,
        missionStatus: 35,
        dateStart: moment().startOf('month').format('YYYY-MM-DD'),
        dateEnd: moment().format('YYYY-MM-DD'),
    }

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.downloadMissions})
        if (this.props.onClose) this.props.onClose()
    }

    handleLink = link => {
        return window.open(`${link}`, '_blank')
    }

    _download = async () => {
        try {
            const {
                closeLoadingMask,
                openLoadingMask,
                user,
                exportMissoin,
                exportMissionAdminMedical,
                openErrorDialog
            } = this.props
            const {
                identity,
                livingArea, //for overseas
                missionType,
                missionStatus,
                dateStart,
                dateEnd
            } = this.state

            openLoadingMask()

            const exportMissionParams = { identity, livingArea, missionType, missionStatus, dateFrom: dateStart, dateTo: dateEnd }

            let exportLink = null
            switch (user.role) {
                case 'cc':
                case 'admin':
                    exportLink = await exportMissoin(exportMissionParams)
                    break
                case 'adminMedical':
                    exportLink = await exportMissionAdminMedical(exportMissionParams)
                    break
            }
            if (exportLink && exportLink.link) this.handleLink(exportLink.link)
            else openErrorDialog({ title: 'Export Error', message: '匯出失敗請聯絡客服' })

            closeLoadingMask()

        } catch (e) {
            // Case Error
            const {openErrorDialog} = this.props
            if(typeof (e.error) !== "string")

            openErrorDialog({title: e.status ? `錯誤代碼 ${e.status}` : '', message: e.error})
            console.warn('Error = ', e)
        }
    }

    render() {
        const {classes, downloadMissions} = this.props

        if (!downloadMissions || downloadMissions.props.open === false) return <div/>

        return (
            <Dialog className={classes.root} {...downloadMissions.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            下載任務列表
                        </Typography>
                    </Toolbar>
                </AppBar>

                <DialogContent className="flex flex-col" classes={{root: "p-24"}}>
                    {/* display option and download */}

                    <div className="flex">
                        <div className="min-w-48 pt-16">
                            <Icon color="action">today</Icon>
                        </div>
                        <div className="flex-auto">
                            <Typography className="text-12"> 今天日期 </Typography>
                            <Typography className="text-16 pb-24" > {`${moment().format('YYYY-MM-DD')}`} </Typography>
                        </div>
                    </div>
                    <UecareDropdown
                        label="任務類型"
                        icon="assignment"
                        name="missionType"
                        id="missionType"
                        className={classes.formControl}

                        value={this.state.missionType}
                        options={
                            [
                                {id: 3, name: '顧問諮詢'},
                                {id: 1, name: '24HR急診諮詢'},
                                {id: 13, name: '追蹤諮詢'},
                                {id: 14, name: '快篩陽性'},
                            ]
                        }
                        onChange={event => this.setState({missionType: event.target.value})}
                    />
                    {/*<UecareDropdown
                        label="任務狀態"
                        name="missionStatus"
                        id="missionStatus"
                        className={classes.formControl}
                        value={this.state.missionStatus}
                        options={
                            [
                                {id: 35, name: '預約完成'},
                                {id: 14, name: '諮詢室已關'},
                                {id: 5, name: '任務完成'},
                                {id: 19, name: '醫師完成建議'},
                                {id: 6, name: '失敗'},
                                {id: 7, name: '取消'}
                            ]
                        }
                        onChange={event => this.setState({missionStatus: event.target.value})}
                    />*/}
                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">date_range</Icon>
                        </div>
                        <TextField
                            id="dateFrom"
                            name="dateFrom"
                            label="開始時間"
                            type="date"
                            className={classes.formControl}
                            InputLabelProps={{
                                shrink: true
                            }}
                            value={this.state.dateStart}
                            onChange={date => this.setState({dateStart: date.target.value})}
                        />
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20"/>
                        <TextField
                            id="dateTo"
                            name="dateTo"
                            label="結束時間"
                            type="date"
                            className={classes.formControl}
                            InputLabelProps={{
                                shrink: true
                            }}
                            value={this.state.dateEnd}
                            onChange={date => this.setState({dateEnd: date.target.value})}
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button variant="raised" color="secondary" onClick={() => this._download()}>下載班表</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openErrorDialog: ReduxGlobal.ActionCreator.openErrorDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        exportMissoin: ReduxMission.ActionCreator.exportMission,
        exportMissionAdminMedical: ReduxMission.ActionCreator.exportMissionAdminMedical,
    }, dispatch)
}

function mapStateToProps({global: {dataDialogs}, auth}) {
    return {
        downloadMissions: dataDialogs[constDataDialogs.name.downloadMissions],
        user: auth.user,
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(DownloadMissions))



// WEBPACK FOOTER //
// ./src/components/DownloadMission.js